import * as React from "react";
import { forwardRef } from "react";
const SvgActiveIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 5, r: 5, fill: "#20BF6B" }));
const ForwardRef = forwardRef(SvgActiveIcon);
export default ForwardRef;
